@layer ch-grid {
    ch-grid-action-settings[disabled] {
        pointer-events: none;
    }
}